/** Dispatched by "Take the tour" in Help; the tour mounted in the shell listens for it. */
export const START_TOUR_EVENT = 'pos:start-tour';

export function startDashboardTour(): void {
  window.dispatchEvent(new Event(START_TOUR_EVENT));
}
